import * as S from "./SectionTranscript.styled";

import { Player } from "@/components/Player/Player";
import { Transcription } from "@/components/Transcription/Transcription";
import { AutoScrollProvider } from "@/providers/AutoScrollContext";
import { useBaseStore } from "@/store/store";

export function SectionTranscript() {
  const isExpanded = useBaseStore((state) => state.isExpanded);

  return (
    <S.Container isExpanded={isExpanded} data-test="transcript-section">
      <AutoScrollProvider>
        <Transcription />
        <Player />
      </AutoScrollProvider>
    </S.Container>
  );
}
